import { z } from 'zod';

import { levelEnumValidator } from '../../validators';

export const ExtractWordsSchema = z.object({
  count: z
    .number()
    .int()
    .min(1, 'Count must be at least 1')
    .max(300, 'Count cannot exceed 300')
    .optional()
    .default(100),
  level: levelEnumValidator.optional(),
  text: z.string().min(1, 'Text cannot be empty.'),
});

export type IExtractWordsDto = z.infer<typeof ExtractWordsSchema>;
